import { render, staticRenderFns } from "./EditQuestion.vue?vue&type=template&id=bc28e4a4&scoped=true&"
import script from "./EditQuestion.vue?vue&type=script&lang=js&"
export * from "./EditQuestion.vue?vue&type=script&lang=js&"
import style0 from "./EditQuestion.vue?vue&type=style&index=0&id=bc28e4a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc28e4a4",
  null
  
)

export default component.exports